import { Skeleton } from "@/components";
import { Alert } from "@/utils/ui/Alert/Alert";
import MediaDetailsForm from "../MediaDetail/MediaDetailsForm";
import { RootState, store } from "@/store/index";
import { connect, ConnectedProps } from "react-redux";
import { AlertDialog } from "@/utils/ui/AlertDialog/AlertDialog";
import {
  deleteMedia,
  getAdminCurrentPresetDetails,
  getAssets,
  getCreditList,
  getPresetList,
  getSearchedListMedia,
  getUpdateMedia,
  updatePublishMedia,
} from "@/store/media/media.action";
import { setIsRootLoading } from "@/store/app/app.slice";
import { useEffect, useState } from "react";
import {
  PresetListModel,
  AllHostsList,
  MostFrequestModel,
  UserModel,
  BunchCategoryModel,
  GenericSocialPublish,
  CreditModel,
  Option,
  AdminPreset,
} from "@/database";
import {
  getMostFrequentNoIndex,
  getMostFrequentAll,
} from "@/store/user/user.action";

import {
  useNavigate,
  useOutletContext,
  useSearchParams,
  useLocation,
} from "react-router-dom";
import { getListMedia } from "@/store/media/media.action";
import {
  addMediaAsset,
  emptyAssetDetails,
  setIsEditPageChanged,
} from "@/store/media/media.slice";
import { updateModal } from "@/store/app/app.slice";
import { setIsMandatoryMetaFilled } from "@/store/media/media.slice";
import { getLiveList } from "@/store/media/media.action";
import {
  updateIsClearFilter,
  updateIsFilter,
} from "@/store/media/media.action";

import { getListUser } from "@/store/user/user.action";
import { getListAgencies } from "@/store/constants/constants.action";
import { CONTENT_TYPE, PRODUCTION_TYPE } from "@/utils/constants/uiConstants";
import { getCurrentPresetDetails } from "@/store/media/media.action";
import { ProductModel, LiveMeta } from "@/database";
import { truncateText } from "@/utils/utilFunctions/truncateText";
import {
  getAdminPresetList,
  getGlobalFavSectionList,
} from "@/store/media/media.action";

interface IWizard {
  isWizard?: boolean;
  closeHandler?: () => void;
  openPublish?: () => void;
  closeModal?: () => void;
  clearFilters?: boolean;
  premiereData?: any;
}

const MediaDetails = ({
  currentMediaDetailsForEdit,
  assets,
  isLoadingMediaDetails,
  getUpdateMedia,
  categories,
  deleteMedia,
  rootLoading,
  isWizard = false,
  closeHandler,
  openPublish,
  mostFrequentUsers,
  currentUser,
  mostFrequentEditor,
  mostFrequentAnchor,
  mostFrequentCameraman,
  mostFrequentScriptWriter,
  mostFrequentContentType,
  mostFrequentCategory,
  currentMediaDetailsId,
  denmarkHosts,
  getListMedia,
  addMediaAsset,
  updateModal,
  setIsMandatoryMetaFilled,
  getLiveList,
  liveList,
  parentMediaList,
  audioCreditList,
  videoCreditList,
  imageCreditList,
  activeCustomUploadTab,
  productDetailsFromConstant,
  closeModal,
  getMostFrequentAll,
  constUserList,
  getPresetList,
  presetList,
  getAssets,
  updateIsClearFilter,
  updateIsFilter,
  clearFilters = true,
  getListUser,
  getListAgencies,
  bunchCategoryList,
  bunchLanguageList,
  bunchProductList,
  bunchBusinessList,
  hosts,
  currentPresetDetails,
  getCurrentPresetDetails,
  getAdminCurrentPresetDetails,
  adminCurrentPresetDetails,
  defaultTeam,
  defaultBusiness,
  userList,
  hostSubsection,
  allHostsList,
  getAdminPresetList,
  adminPresetList,
  updatePublishMedia,
  premiereData,
  getGlobalFavSectionList,
}: Props) => {
  const [socialPublishList, setSocialPublishList] = useState<any[]>([]);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [metaPresetData, setMetaPresetData] = useState<AdminPreset>(
    {} as AdminPreset
  );
  const navigateTo = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const outletContext = useOutletContext<{
    hasChanges: boolean;
    setHasChanges: (value: boolean) => void;
    handleTempThumbnailImageUrl?: (
      url: string | undefined,
      id: string | undefined
    ) => void;
    handleIsWizard?: (value: boolean) => void;
    handleConfirmModalOpen?: (open: boolean) => void;
    isConfirmModalOpen?: boolean;
    handleSetReadOnlyAccess?: (readOnly: boolean) => void;
    goToSocialPublish?: () => void;
  }>();
  const { setHasChanges } = outletContext || { setHasChanges: () => {} };
  const { handleTempThumbnailImageUrl } = outletContext || {
    handleTempThumbnailImageUrl: () => {},
  };
  const { handleIsWizard } = outletContext || { handleIsWizard: () => {} };
  const { handleConfirmModalOpen } = outletContext || {
    handleConfirmModalOpen: () => {},
  };
  const { isConfirmModalOpen } = outletContext || { isConfirmModalOpen: false };
  const { handleSetReadOnlyAccess } = outletContext || {
    handleSetReadOnlyAccess: () => {},
  };
  useEffect(() => {
    handleIsWizard && handleIsWizard(isWizard);
  }, []);

  const isReadOnlyMode = (() => {
    if (!currentMediaDetailsForEdit?.team || !bunchProductList?.length) {
      return false;
    }
    const currentTeam = bunchProductList.find(
      (team: ProductModel) => team.id === currentMediaDetailsForEdit.team
    );
    return currentTeam?.access === "read";
  })();

  useEffect(() => {
    getAdminPresetList({ keys: ["meta_preset"], status: "active" });
  }, []);

  useEffect(() => {
    handleSetReadOnlyAccess && handleSetReadOnlyAccess(isReadOnlyMode);
  }, [isReadOnlyMode, handleSetReadOnlyAccess]);

  const handleHasChanges = (changes: boolean) => {
    setHasUnsavedChanges(changes);
    if (setHasChanges) {
      setHasChanges(changes);
    }
    store.dispatch(setIsEditPageChanged(changes));
  };
  const searchparams = useSearchParams();

  useEffect(() => {
    if (currentMediaDetailsForEdit?.id) {
      getAssets({
        pid: currentMediaDetailsForEdit?.simulive?.parentMediaId
          ? currentMediaDetailsForEdit.simulive.parentMediaId
          : currentMediaDetailsForEdit.id,
      });
    }

    return () => {
      emptyAssetDetails();
    };
  }, [currentMediaDetailsForEdit?.id]);

  const createMFUArray = (mfuData: MostFrequestModel[] = []): Option[] => {
    return mfuData
      ?.map((item: MostFrequestModel) => {
        const user = constUserList?.find(
          (user: UserModel) => user.id === item.id
        );
        if (user) {
          return {
            label: ` ${user.name} ${
              user.email ? "(" + truncateText(user.email, 20) + ")" : ""
            }`,
            value: user.id,
          };
        }
        return null;
      })
      .filter((item: Option | null): item is Option => item !== null);
  };

  // Create MFU arrays using the helper function
  const mfuEditor = createMFUArray(mostFrequentEditor);
  const mfuAnchor = createMFUArray(mostFrequentAnchor);
  const mfuScriptWriter = createMFUArray(mostFrequentScriptWriter);
  const mfuCameraman = createMFUArray(mostFrequentCameraman);
  const mfuProducer = createMFUArray(mostFrequentUsers);

  useEffect(() => {
    if (defaultTeam && defaultTeam?.settings?.host) {
      let hostId = defaultTeam?.settings?.host;
      if (hostId === "none") {
        hostId = "";
      }
    }
  }, [defaultTeam]);

  useEffect(() => {
    // getLiveList();
    // getPresetList({ type: "meta", status: 1 } as PresetListModel);
    const requestKeys = [
      "ctype",
      "producer",
      "editor",
      "anchor",
      "cameraman",
      "script_writer",
      "category",
    ];
    const request = requestKeys.map((key) => ({
      terms: {
        field: "value",
        size: 7,
      },
      key,
      mfu: true,
    }));

    getMostFrequentAll({ requests: request });
  }, []);

  function mapCategoryListToObject(categories: BunchCategoryModel[]) {
    return categories.reduce(
      (acc, cat) => {
        acc[cat.name] = cat.sub_meta || [];
        return acc;
      },
      {} as Record<string, any[]>
    );
  }

  useEffect(() => {
    if (
      adminPresetList?.meta_preset &&
      adminPresetList?.meta_preset?.length > 0
    ) {
      const presetId = localStorage.getItem("metaPresetId");

      const presetData = adminPresetList?.meta_preset?.find(
        (item: AdminPreset) => item?.id === presetId
      );
      setMetaPresetData(presetData || ({} as AdminPreset));
    } else {
      setMetaPresetData({} as AdminPreset);
    }
  }, [adminPresetList?.meta_preset, currentMediaDetailsForEdit?.preset_config]);

  const handleConfirmClose = () => {
    if (handleConfirmModalOpen) {
      handleConfirmModalOpen(false);
    }
    const state = location.state as {
      fromChapter?: boolean;
      mediaId?: string;
      chapterId?: string;
      returnPath?: string;
    } | null;

    if (state?.fromChapter) {
      navigateTo(-1);
      return;
    }

    const cleanParams = new URLSearchParams();
    const tabParam = searchParams.get("tab");
    const isDriveTab = tabParam === "drive";
    for (const [key, value] of searchParams.entries()) {
      if (key !== "nextInit" && key !== "navigateOptions" && value) {
        cleanParams.append(key, value);
      }
    }
    emptyAssetDetails();
    if (isDriveTab) {
      // Remove 'tab' param — drive listing is path-based, not tab-param-based
      cleanParams.delete("tab");
      const qs = cleanParams.toString();
      const drivePath =
        currentMediaDetailsForEdit?.asset_type === "shorts"
          ? "/drive/shorts"
          : "/drive/video";
      navigateTo(qs ? `${drivePath}?${qs}` : drivePath);
    } else {
      // Navigate straight to the tab's own route (e.g. /media/video) rather
      // than the bare /media index — landing on the index causes MediaList
      // to redirect itself via navigate(), which remounts it a second time
      // and loses the "returning from detail" cache-reuse flag, causing the
      // page-overflow guard to briefly see a reset count and snap back to
      // page 1.
      cleanParams.delete("tab");
      const qs = cleanParams.toString();
      const listPath = `/media/${tabParam || "video"}`;
      navigateTo(qs ? `${listPath}?${qs}` : listPath);
    }
  };

  useEffect(() => {
    if (currentMediaDetailsForEdit?.socials) {
      const updatedPublishList = Array.isArray(
        currentMediaDetailsForEdit.socials
      )
        ? currentMediaDetailsForEdit.socials.map(
            (thirdParty: GenericSocialPublish) => ({
              job_type: thirdParty.job_type,
              id: thirdParty.id,
              published_id: thirdParty?.published_id,
              video_url: thirdParty.video_url,
              channel_name: thirdParty.channel_name,
              status: thirdParty.status,
              mt: thirdParty.mt,
              ct: thirdParty.ct,
              msg: thirdParty.msg,
              platform: thirdParty.job_type,
              schedule: thirdParty.schedule,
              host: "host" in thirdParty ? thirdParty.host : undefined,
              image:
                thirdParty?.job_type === "facebook"
                  ? `https://graph.facebook.com/${thirdParty.platform}/picture?type=large`
                  : thirdParty.image,
            })
          )
        : [];
      const updatedSocialPublishList = updatedPublishList.filter(
        (item) =>
          item.job_type !== "denmark" && item.job_type !== "denmark_embed"
      );
      setSocialPublishList(updatedSocialPublishList);
    }
  }, [currentMediaDetailsForEdit?.socials]);

  if (isLoadingMediaDetails || rootLoading) {
    return (
      <div className="px-3 py-3">
        <Skeleton type="title" width="220px" />
        <div className="row mt-3 g-3">
          <div className="col-12">
            <Skeleton type="thumbnail" height={260} />
          </div>
          <div className="col-md-6">
            <Skeleton type="text" height={42} />
          </div>
          <div className="col-md-6">
            <Skeleton type="text" height={42} />
          </div>
          <div className="col-md-4">
            <Skeleton type="text" height={42} />
          </div>
          <div className="col-md-4">
            <Skeleton type="text" height={42} />
          </div>
          <div className="col-md-4">
            <Skeleton type="text" height={42} />
          </div>
          <div className="col-12">
            <Skeleton type="text" height={100} />
          </div>
          <div className="col-12">
            <Skeleton type="text" height={100} />
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      {isReadOnlyMode && (
        <Alert variant="warning" className="m-3">
          You are in read-only mode. You cannot edit this media.
        </Alert>
      )}
      <MediaDetailsForm
        clearFilters={clearFilters}
        updateModal={updateModal}
        productDetailsFromConstant={productDetailsFromConstant}
        currentMediaDetailsForEdit={currentMediaDetailsForEdit}
        currentMediaDetailsId={currentMediaDetailsId}
        closeHandler={closeHandler}
        isWizard={isWizard}
        openPublish={openPublish}
        onOpenSocialPublish={outletContext?.goToSocialPublish}
        handleSave={getUpdateMedia}
        activeCustomUploadTab={activeCustomUploadTab}
        categories={categories}
        setIsMandatoryMetaFilled={setIsMandatoryMetaFilled}
        denmarkHosts={denmarkHosts}
        currentUser={currentUser}
        closeModal={closeModal}
        addMediaAsset={addMediaAsset}
        socialPublishList={socialPublishList}
        getListMedia={getListMedia}
        deleteMedia={deleteMedia}
        parentMediaList={parentMediaList}
        defaultTeam={defaultTeam}
        liveList={liveList?.map((item: LiveMeta) => {
          return {
            label: item?.title,
            value: item?.id,
          };
        })}
        assets={assets}
        handleTempThumbnailImageUrl={handleTempThumbnailImageUrl || (() => {})}
        audioCreditList={audioCreditList?.list?.map((val: CreditModel) => {
          return {
            label: ` ${val?.name}  ${
              val?.email ? "(" + truncateText(val?.email, 20) + ")" : ""
            } `,
            value: val?.id,
          };
        })}
        videoCreditList={videoCreditList?.list?.map((val: CreditModel) => {
          return {
            label: ` ${val?.name}  ${
              val?.email ? "(" + truncateText(val?.email, 20) + ")" : ""
            } `,
            value: val?.id,
          };
        })}
        imageCreditList={imageCreditList?.list?.map((val: CreditModel) => {
          return {
            label: ` ${val?.name}  ${
              val?.email ? "(" + truncateText(val?.email, 20) + ")" : ""
            } `,
            value: val?.id,
          };
        })}
        contentType={CONTENT_TYPE}
        productionType={PRODUCTION_TYPE}
        producers={mfuProducer}
        editors={mfuEditor}
        scriptWriters={mfuScriptWriter}
        anchors={mfuAnchor}
        cameramans={mfuCameraman}
        ctypes={mostFrequentContentType?.map((val: MostFrequestModel) => {
          return {
            label: val.name,
            value: val.id,
            email: val?.email,
          };
        })}
        mfcategories={mostFrequentCategory?.map((val: MostFrequestModel) => {
          return {
            label: val.name,
            value: val.id,
            email: val?.email,
          };
        })}
        onHasChanges={handleHasChanges}
        presetList={presetList}
        adminPresetList={adminPresetList}
        constUserList={constUserList}
        updateIsClearFilter={updateIsClearFilter}
        updateIsFilter={updateIsFilter}
        metaPresetData={metaPresetData}
        getListUser={getListUser}
        getListAgencies={getListAgencies}
        bunchCategoryList={bunchCategoryList}
        bunchLanguageList={bunchLanguageList}
        bunchProductList={bunchProductList}
        hostSubsection={hostSubsection}
        bunchBusinessList={bunchBusinessList}
        subCategoryList={mapCategoryListToObject(bunchCategoryList)}
        hosts={hosts}
        defaultBusiness={defaultBusiness}
        contributorsList={userList?.list?.map((item: UserModel) => {
          return {
            label: ` ${item?.name}  ${
              item?.email ? "(" + truncateText(item?.email, 20) + ")" : ""
            } `,
            value: item.id,
          };
        })}
        getCurrentPresetDetails={getCurrentPresetDetails}
        getAdminCurrentPresetDetails={getAdminCurrentPresetDetails}
        adminCurrentPresetDetails={adminCurrentPresetDetails}
        currentPresetDetails={currentPresetDetails}
        allHostsList={allHostsList}
        updatePublishMedia={updatePublishMedia}
        premiereData={premiereData}
        getGlobalFavSectionList={getGlobalFavSectionList}
      />
      {isConfirmModalOpen && hasUnsavedChanges && (
        <AlertDialog
          isOpen={isConfirmModalOpen}
          onClose={() =>
            handleConfirmModalOpen && handleConfirmModalOpen(false)
          }
          onConfirm={handleConfirmClose}
          title="ALERT!"
          message="Are you sure you want to leave? Any unsaved changes will be lost."
          confirmText="Confirm"
          cancelText="Cancel"
          confirmButtonType="warning"
        />
      )}
    </>
  );
};

const mapState = (state: RootState) => ({
  currentMediaDetailsForEdit: state.media.mediaDetails.media,
  isLoadingMediaDetails: state.media.mediaDetails.isLoading,
  categories: state.app.categories,
  rootLoading: state.app.rootLoading,
  userList: state.users.userList,
  assets: state.media.mediaAssets.assets,
  mostFrequentUsers: state.users.mostFrequentUsers.list,
  mostFrequentEditor: state.users.mostFrequentEditor.list,
  mostFrequentScriptWriter: state.users.mostFrequentScriptWriter.list,
  mostFrequentAnchor: state.users.mostFrequentAnchor.list,
  mostFrequentCameraman: state.users.mostFrequentCameraman.list,
  mostFrequentContentType: state.users.mostFrequentContentType.list,
  mostFrequentCategory: state.users.mostFrequentCategory.list,
  parentMediaList: state.media.parentMediaList.list,
  currentMediaDetailsId: state.media.mediaDetails.media.id,

  creditList: state.media.creditList,
  currentUser: state?.users?.singleCurrentUser?.id,
  liveList: state.media.liveList.list,
  audioCreditList: state.media.audioCreditList,
  videoCreditList: state.media.videoCreditList,
  imageCreditList: state.media.imageCreditList,
  activeCustomUploadTab: state.media.activeCustomUploadTab,
  productDetailsFromConstant: state.app.productList,
  constUserList: state.app.constUserList,
  presetList: state.media.presetList.list,
  agenciesList: state.constants.agenciesList,
  bunchCategoryList: state.constants.bunchCategoryList.list,
  bunchLanguageList: state.constants.bunchLanguageList.list,
  bunchProductList: state.constants.bunchProductList.list,
  bunchBusinessList: state.constants.bunchBusinessList.list,
  hosts: state.media.hostList.list,
  defaultTeam: state.constants.defaultTeam,
  defaultBusiness: state.constants.defaultBusiness,
  currentPresetDetails: state.media.currentPresetDetails,
  hostSubsection: state.media.hostSubSection.list,
  allHostsList: state.constants.allHostsList.list,
  adminPresetList: state.media.adminPresetList.list,
  adminCurrentPresetDetails: state.media.adminCurrentPresetDetails,
  denmarkHosts:
    state.constants.allHostsList.list &&
    Array.isArray((state.constants.allHostsList.list as AllHostsList)?.hosts)
      ? (state.constants.allHostsList.list as AllHostsList)?.hosts
      : Array.isArray(state.constants.allHostsList.list)
        ? state.constants.allHostsList.list
        : [],
});
const mapDispatch = {
  getUpdateMedia,
  setIsRootLoading,
  deleteMedia,
  updatePublishMedia,
  getSearchedListMedia,
  getCreditList,
  getMostFrequentNoIndex,
  getListMedia,
  addMediaAsset,
  emptyAssetDetails,
  updateModal,
  setIsMandatoryMetaFilled,
  getLiveList,
  getMostFrequentAll,
  getPresetList,
  getAssets,
  updateIsClearFilter,
  updateIsFilter,
  getListUser,
  getListAgencies,
  getCurrentPresetDetails,
  getAdminPresetList,
  getAdminCurrentPresetDetails,
  getGlobalFavSectionList,
};
const connector = connect(mapState, mapDispatch);
type Props = ConnectedProps<typeof connector> & IWizard;
export default connector(MediaDetails);
